import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { TemplateModal } from './TemplateModal'
import { useRootStore } from 'stores/RootStore'
import { TemplateModalProps } from './Types'

interface TemplateDrawerProps extends TemplateModalProps, DrawerProps {}

export const TemplateDrawer = observer((props: TemplateDrawerProps) => {
  const { closeDrawer } = useRootStore().drawersStore

  return (
    <Drawer.Root {...props}>
      <Drawer.Portal>
        <Drawer.Content fullHeight>
          <Drawer.InnerContent isSnappedTop>
            <Drawer.Container padding="0px">
              <TemplateModal onClose={closeDrawer} {...props} />
            </Drawer.Container>
          </Drawer.InnerContent>
        </Drawer.Content>
        <Drawer.Overlay />
      </Drawer.Portal>
    </Drawer.Root>
  )
})
